export type FileRecordRejectionDetails = {
    reason: string;
    details?: string;
    courseOfAction?: string;
    fixedBilling?: string;
};

export type FileRecordWaitingForClientResponseDetails = {
    details?: string;
    courseOfAction?: string;
    fixedBilling?: string;
};

export type FileRecordStatusDetails = FileRecordRejectionDetails | FileRecordWaitingForClientResponseDetails;

export const isFileRecordRejectionDetails = (
    statusDetails: FileRecordStatusDetails
): statusDetails is FileRecordRejectionDetails => {
    return "reason" in statusDetails;
};
